// ============================================================================
// File:
// src/modules/ppe/pages/procurement/dashboard/components/kpi/KPICard.jsx
// Purpose: Premium Gradient KPI Card (SAFE VERSION)
// ============================================================================

import React from "react";
import "./kpi.css";

export default function KPICard({
  title,
  value,
  currency = false,
  gradient = "blue"
}) {

  return (
      <div className={`kpi-card kpi-${gradient}`}>
      {/* Title */}
      <div className="kpi-title">
        {title}
      </div>

      {/* Value */}
      <div className="kpi-value">

        {currency && (
          <span className="currency">₹</span>
        )}

        {value}

      </div>

    </div>
  );
}
